import { Stack } from "@mui/material";
import { DynamicEchartsChart } from "components/chart/DynamicChartMemoized";
import { formatNumberBasedOnUser } from "utils/namesManipulation";

import type { EnergyAnalysisCategoryTotal, EnergyAnalysisTotalChartType } from "../model/types";

import { buildTotalChartOption } from "../lib/buildTotalChartOption";
import { withEnergyAnalysisChartStyle } from "../lib/chartStyle";

type EnergyAnalysisTotalChartCanvasProps = {
  categoryTotals: EnergyAnalysisCategoryTotal[];
  chartType: EnergyAnalysisTotalChartType;
  showCenter: boolean;
  snapshotValueMax: number;
  totalValue: number;
  unit: string;
};

export const EnergyAnalysisTotalChartCanvas = ({
  categoryTotals,
  chartType,
  showCenter,
  snapshotValueMax,
  totalValue,
  unit,
}: EnergyAnalysisTotalChartCanvasProps) => (
  <div className="relative h-[29rem] w-full [&_h3]:hidden">
    <DynamicEchartsChart
      className="h-full w-full"
      option={withEnergyAnalysisChartStyle(
        buildTotalChartOption(categoryTotals, chartType, snapshotValueMax)
      )}
      secondYAxisRange={undefined}
      style={{ height: "100%" }}
      title={undefined}
      tooltip={undefined}
      xAxisRange={undefined}
      yAxisRange={undefined}
    />
    {showCenter ? (
      <Stack className="pointer-events-none absolute inset-0 flex-col justify-center">
        <span className="text-lds-foreground-heading-active font-ds-number-semibold-xl">
          {formatNumberBasedOnUser(totalValue, 2)}
        </span>
        <span className="font-ds-body-regular-sm text-lds-foreground-muted">{unit}</span>
      </Stack>
    ) : null}
  </div>
);
